import { Map } from 'immutable';

export default Map({
  loading: false,
  data: [],
  error: null,
});
